import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

import { Namespace, ParseKeys } from 'i18next';

interface AccordionActionButtonsProps {
	cancelLabel?: ParseKeys<Namespace>;
	disableSubmit?: boolean;
	onClose?: () => void;
	submitLabel?: ParseKeys<Namespace>;
	onClick?: () => void;
}

export const AccordionActionButtons = ({
	cancelLabel = 'commonButton:cancel',
	disableSubmit = false,
	onClose,
	submitLabel = 'commonButton:save',
	onClick,
}: AccordionActionButtonsProps) => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				gap: 2,
				display: 'flex',
				flexDirection: 'row-reverse',
			}}>
			<Button
				variant="contained"
				color="secondary"
				disableElevation
				disabled={disableSubmit}
				type={onClick ? 'button' : 'submit'}
				onClick={onClick}>
				{t(submitLabel, { defaultValue: 'error-unexpected' })}
			</Button>
			{onClose && (
				<Button
					variant="outlined"
					color="secondary"
					disableElevation
					type="button"
					onClick={onClose}>
					{t(cancelLabel, { defaultValue: 'error-unexpected' })}
				</Button>
			)}
		</Box>
	);
};
